import { Stack } from '@chakra-ui/react';
import { Order } from '@diamond/shared/types';
import { CardPromoInfo } from '@diamond/shared/ui';
import { extractOrderPromoBannerData } from '@diamond/sol-buyer/utils';

interface OrderPromoBannerSummaryProps {
  order: Order;
}

export const OrderPromoBannerSummary = ({
  order,
}: OrderPromoBannerSummaryProps) => {
  const promoBanners = extractOrderPromoBannerData(order.items);

  if (promoBanners.length === 0) {
    return null;
  }

  return (
    <Stack spacing="4" mt="4" mb="8" px={{ base: 0, md: 6 }}>
      {promoBanners.map((banner) => {
        if (banner.type === 'cashback') {
          return (
            <CardPromoInfo
              key={banner.voucherId}
              type="cashback"
              duration={banner.dateRange}
              text={banner.text}
            />
          );
        }
        if (banner.type === 'discount') {
          return (
            <CardPromoInfo
              key={banner.voucherId}
              type="discount"
              duration={banner.dateRange}
              text={banner.text}
              discountDisplay={banner.discountDisplay}
              images={banner.images}
            />
          );
        }
        return (
          <CardPromoInfo
            key={banner.voucherId}
            type="free-item"
            duration={banner.dateRange}
            text={banner.text}
            item={banner.item!}
            images={banner.images}
            savings={banner.savings}
            showFreeItemPrice={false}
          />
        );
      })}
    </Stack>
  );
};
